import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { CommonServices } from '../services/commonServices';
const commonServices = new CommonServices();

import { Loadingfuction } from '../store/reducers/loading.reducer';
import Image from '../widget/w-image';

interface VerifyProps {}
const VerifyPage: React.FC<VerifyProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [platformData, setplatformData] = useState(null);

  useEffect(() => {
    if (window.location.pathname.includes('/verify')) {
      const params = new URLSearchParams(window.location.search);

      // If no params exist → redirect
      if (!params.keys().next().value) {
        sessionStorage.clear();
        navigate('/invalid_token');
        return;
      }
      const queryObject: Record<string, string> = {};

      params.forEach((value, key) => {
        queryObject[key] = decodeURIComponent(value);
      });

      if (queryObject.aws_identifier) {
        const temp = {
          provider: 'AWS',
          identifier: queryObject.aws_identifier.replace(/['"]/g, ''),
        };
        gettingIdentifierDetails(temp);
        setplatformData(temp);
        sessionStorage.setItem('platform', JSON.stringify(temp));
      } else {
        setplatformData(null);
      }
    } else {
      console.error('Invalid path');
    }
  }, []);

  const gettingIdentifierDetails = (data) => {
    commonServices
      .getDetails(data)
      .then((res) => {
        console.log(res.data);
        if (!res.data || Object.keys(res.data).length === 0) {
          navigate('/invalid_token');
          sessionStorage.clear();
          return;
        }
        if (res.data) {
          if (res?.data?.already_register) {
            sessionStorage.setItem('Details', JSON.stringify(res.data));
            sessionStorage.removeItem('platform');
            navigate('/verified');
          } else {
            sessionStorage.setItem('Details', JSON.stringify(res.data));
            navigate('/register');
          }
        }
      })
      .catch((error) => {
        navigate('/invalid_token');
        sessionStorage.clear();
      });
  };

  return (
    <div className='d-flex align-items-center justify-content-center flex-column vh-75'>
      <Image
        imageClass='loader_css'
        src='/asset/Loader.gif'
        alt='Loading'
        ariaLabel='Loading'
      ></Image>
      <div id='loading-description' className='content-hide text_subheding_bold'>
        Checking
      </div>
      <span className='fw-medium p-2 rounded-2 mx-2'>Verifying</span>
    </div>
  );
};
export default VerifyPage;
